import { Typography } from '@mui/material';
import type { FC } from 'react';
import { tooltipCell } from './styles';

interface ProjectStringDisplayProps {
    data: string;
    fullCell?: boolean;
}

const ProjectStringDisplay: FC<ProjectStringDisplayProps> = ({ data, fullCell }) => (
    <Typography sx={{ ...tooltipCell, ...(fullCell && { height: 1, width: 1 }) }}>{data}</Typography>
);

export default ProjectStringDisplay;
